import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';


@Component({
	selector: 'app-case-log-image',
	templateUrl: './case-log-image.component.html',
	styleUrls: ['./case-log-image.component.scss']
})
export class CaseLogImageComponent implements OnInit {

	public caseLogs: Array<object> = [];

	constructor(
		public ptImageMappingService : PtImageMappingService,
		public dialogRef: MatDialogRef<CaseLogImageComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData:any) {
	}

	ngOnInit(): void {
		// TO GET THE SPECIMEN LOGS
		if(this.dailogData.siteCode){
			this.getAnatomicSiteLogs();
		}

		// TO GET THE CASE NUMBER LOGS
		if(this.dailogData.caseNumberID){
			this.getCaseNumberLogs();
		}
	}

	getAnatomicSiteLogs = () => {
		this.ptImageMappingService.getAnatomicSiteLogs(this.dailogData.siteCode, this.dailogData.actionDiagnosis).subscribe( (result: any) => {
			this.caseLogs = result.logData.sort( (a, b) => +new Date(b.lastUpdatedDate) - +new Date(a.lastUpdatedDate));
		});
	}

	getCaseNumberLogs = () => {
		this.ptImageMappingService.getCaseNumberLogs(this.dailogData.caseNumberID).subscribe( (result: any) => {
			this.caseLogs = result.logData.sort( (a, b) => +new Date(b.lastUpdatedDate) - +new Date(a.lastUpdatedDate));
		});
	}

}